import Vue from 'vue';

import Vue2Filters from 'vue2-filters'
import VueMoment from 'vue-moment'

Vue.use(Vue2Filters)
Vue.use(VueMoment)